/* Ein Set im Warenkorb entfernen.

   Das Set steht als mehrere Zeilen im Warenkorb, denn CheckoutChamp liest je
   Zeile eine Produkt-ID mit Menge. Der Entfernen-Knopf des Themes kann nur
   eine Zeile, deshalb dieser eigene: er setzt alle Zeilen des Sets in einem
   Aufruf auf null. Ueber /cart/update.js mit den Schluesseln, nicht ueber
   /cart/change.js mit Zeilennummern, denn die verschieben sich, sobald die
   erste Zeile weg ist.

   Geladen wird die Datei aus layout/theme.liquid, nicht aus dem Snippet.
   Stuende sie nur dort, gaebe es sie nur, wenn beim Seitenaufruf schon ein
   Set im Warenkorb lag: kommt es erst spaeter dazu, wird der Drawer per
   innerHTML nachgezeichnet, und ein so eingefuegtes script-Tag fuehrt der
   Browser nicht aus. Der Knopf war dann ein totes Element. */
(function () {
  if (customElements.get('bundle-remove-button')) return;

  class BundleRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.entfernen();
      });
    }

    get behaelter() {
      return this.closest('cart-items') || this.closest('cart-drawer-items');
    }

    /* Die Theme-Fassung greift ungeprueft auf `main-cart-items` zu und wirft,
       wenn es die Seite nicht gibt. Ohne diesen Schutz flog die Ausnahme aus
       entfernen() heraus, bevor ueberhaupt ein Aufruf lief -- und `busy`
       blieb stehen, sodass auch jeder weitere Klick folgenlos war. */
    abschnitte() {
      const w = this.behaelter;
      if (!w || typeof w.getSectionsToRender !== 'function') return [];
      try {
        return w.getSectionsToRender() || [];
      } catch (fehler) {
        return [];
      }
    }

    entfernen() {
      const keys = (this.dataset.keys || '').split(',').filter(Boolean);
      // Nur die Zeilen DIESES Sets. Ueber die Zugaben entscheidet allein der
      // Geschenke-Waechter, denn nur er kennt den ganzen Warenkorb: Liegt noch
      // ein zweites Set darin, steht ein Satz Zugaben weiter zu und wird auf
      // die neue Menge gesetzt statt weggeraeumt. Vorher nahm dieser Knopf
      // immer ALLE Zugaben mit -- wer eines von zwei Sets entfernte, stand
      // ohne jedes Geschenk da. Bleibt gar nichts Gekauftes uebrig, raeumt
      // der Waechter sie ebenso ab; sein Soll ist dann null.
      if (!keys.length || this.busy) return;
      this.busy = true;

      // Sperrt weitere Klicks, blendet aber nicht ab: der Ladekreis haengt im
      // Block und waere sonst mit abgeblendet.
      const block = this.closest('.cart-bundle');
      if (block) block.classList.add('is-going');

      // Der Ladekreis auf JEDER Zeile, die mitgeht. Der Waechter haelt ihn
      // vor; er kennt die Stile, die im Theme an der ID des einen Loaders
      // haengen und einer blossen Kopie fehlen wuerden.
      const nummern = (this.dataset.indices || '').split(',').filter(Boolean);
      const loader = window.__kylaLoader;
      if (loader && nummern.length) loader.zeigen(nummern);

      const updates = {};
      keys.forEach((k) => (updates[k] = 0));

      const sections = this.abschnitte();

      fetch(`${(window.routes && window.routes.cart_update_url) || '/cart/update.js'}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          updates,
          sections: sections.map((s) => s.section),
          sections_url: window.location.pathname,
        }),
      })
        .then((r) => r.json())
        .then((state) => {
          // Einspielen macht der Waechter, wenn er da ist: er schaltet
          // dieselben Klassen und meldet die Aenderung so, dass das Theme
          // NICHT ein zweites Mal laedt.
          if (loader && loader.einspielen) {
            loader.einspielen(state, sections);
            return;
          }

          const leer = state.item_count === 0;
          const wrapper = this.behaelter;
          const drawer = document.querySelector('cart-drawer');
          const footer = document.getElementById('main-cart-footer');
          if (wrapper) wrapper.classList.toggle('is-empty', leer);
          if (drawer) drawer.classList.toggle('is-empty', leer);
          if (footer) footer.classList.toggle('is-empty', leer);

          sections.forEach((section) => {
            const ziel =
              document.getElementById(section.id)?.querySelector(section.selector) ||
              document.getElementById(section.id);
            if (!ziel || !state.sections || !state.sections[section.section]) return;
            const html = new DOMParser().parseFromString(state.sections[section.section], 'text/html');
            const teil = html.querySelector(section.selector);
            if (teil) ziel.innerHTML = teil.innerHTML;
          });

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-items',
              waechter: true,
              cartData: state,
            });
          }
        })
        .catch(() => {
          if (block) block.classList.remove('is-going');
        })
        .finally(() => {
          if (loader) loader.aus();
          this.busy = false;
        });
    }
  }

  customElements.define('bundle-remove-button', BundleRemoveButton);
})();
